import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import ImageZoom from "components/imageZoom/ImageZoom";
import { Box } from "@mui/material";

import "./imageSlider.scss";

const ImageSlider = ({ images = [], alt = "item", quoteText }) => {
  return (
    <Box className="image-slider-container">
      <Swiper slidesPerView={1.1} spaceBetween={10}>
        {images &&
          images.map((image, index) => (
            <SwiperSlide key={index}>
              <div className="slider-image-wrapper">
                <img src={image} alt={alt + index} className={"slider-image"} />
              </div>
            </SwiperSlide>
          ))}
      </Swiper>
      <div className="quote-content">
        <q>{quoteText}</q>
      </div>
    </Box>
  );
};

export default ImageSlider;
